import React from 'react';
import {useSelector} from 'react-redux';


import {BulkActionTool} from 'src/components/bulk-tool';
import {selectDataTableSelection} from 'src/components/data-table-selection/services/data-table-selection-slice';
import {bulkAssignAccountEntitlements, getAssignAccountEntitlementsProgress} from 'src/openapi/admin/apis/BulkAssignAccountEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import Button from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {AssignAccountEntitlementsModal} from './assign-account-entitlements.modal';
import {
    selectAssignAccountEntitlementsBulkUuid,
    selectAssignAccountEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './assign-account-entitlements.slice';
import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';

import type {UpdateEntitlementsRelation} from 'src/openapi/admin/models/UpdateEntitlementsRelation';
import type {AppState} from 'src/store/typedef';

type Props = {
    accountId: number,
    selectionKey: string,
    onDone: () => void,
};

export const AssignAccountEntitlementsTool = ({selectionKey, onDone, accountId}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClick, onClose} = useShown();
    const selection = useSelector((state: AppState) => selectDataTableSelection(state, selectionKey));

    return (
        <>
            <Button disabled={!selection.ids.length} variant="Type.PRIMARY" onClick={onClick}>
                {TOOL_TITLE}
            </Button>
            <BulkActionTool<UpdateEntitlementsRelation>
                shown={shown}
                onClose={onClose}
                width={MODAL_WIDTH}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectAssignAccountEntitlementsTask}
                uuidSelector={selectAssignAccountEntitlementsBulkUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(updateEntitlementsRelation, options) => (
                    apiDispatch(bulkAssignAccountEntitlements({...options, updateEntitlementsRelation}))
                )}
                getProgress={id => apiDispatch(getAssignAccountEntitlementsProgress({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({processAction, onCloseModal}) => (
                    <AssignAccountEntitlementsModal
                        accountId={accountId}
                        ids={selection.ids}
                        onCloseModal={onCloseModal}
                        processAction={processAction}
                    />
                )}
            </BulkActionTool>
        </>
    );
};
